// components/EventSummary/AttendeeItem.js

import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import Typography from '../Typography';
import { theme } from '../../theme';
import HelmetIcon from '../Icons/HelmetIcon';
import { getVehicleIcon, getDefaultIconProps } from '../../utils/vehicleIcons';

const AttendeeItem = ({ attendee }) => {
  if (!attendee) {
    return null;
  }

  // Obtener el icono correspondiente al tipo de vehículo
  const VehicleIconComponent = attendee.vehicleId?.vehicleType ? getVehicleIcon(attendee.vehicleId.vehicleType) : null;

  const iconProps = {
    ...getDefaultIconProps(theme.fill.brandMain),
    width: 28,
    height: 28
  };

  const userId = attendee.userId?._id;

  if (!userId) {
    return (
      <Attendee>
        <AttendeeImages>
          <AvatarPlaceholder>
            <HelmetIcon width={32} height={32} fill={theme.colors.defaultStrong} />
          </AvatarPlaceholder>
        </AttendeeImages>
        <AttendeeInfo>
          <Typography
            $variant="body-3-semibold"
            style={{
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              width: '100%',
              textAlign: 'center'
            }}>
            Usuario no disponible
          </Typography>
        </AttendeeInfo>
      </Attendee>
    );
  }

  return (
    <AttendeeLink to={`/user/${userId}`}>
      <Attendee>
        <AttendeeImages>
          {attendee.userId?.userAvatar ? (
            <AttendeeAvatar
              src={attendee.userId.userAvatar}
              alt="Avatar asistente"
            />
          ) : (
            <AvatarPlaceholder>
              <HelmetIcon width={32} height={32} fill={theme.colors.defaultStrong} />
            </AvatarPlaceholder>
          )}

          {attendee.vehicleId && (
            attendee.vehicleId?.image ? (
              <AttendeeVehicle
                src={attendee.vehicleId.image}
                alt={`${attendee.vehicleId?.brand} ${attendee.vehicleId?.model}`}
              />
            ) : (
              <VehiclePlaceholder>
                {VehicleIconComponent && <VehicleIconComponent {...iconProps} />}
              </VehiclePlaceholder>
            )
          )}
        </AttendeeImages>
        <AttendeeInfo>
          <Typography
            $variant="body-3-semibold"
            style={{
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              width: '100%',
              textAlign: 'center'
            }}>
            {attendee.userId?.name || 'Nombre'} {attendee.userId?.lastName || 'Apellido'}
          </Typography>
          {attendee.vehicleId && (
            <Typography
              $variant="caption-medium"
              color={theme.colors.defaultWeak}
              style={{
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                width: '100%',
                textAlign: 'center'
              }}>
              {attendee.vehicleId.brand || 'Marca'} {attendee.vehicleId.model || 'Modelo'}
            </Typography>
          )}
        </AttendeeInfo>
      </Attendee>
    </AttendeeLink>
  );
};

export default AttendeeItem;

// Styled Components
const AttendeeLink = styled(Link)`
  text-decoration: none;
  color: inherit;
  transition: transform 0.2s ease;
  
  &:hover {
    transform: translateY(-2px);
  }
`;

const Attendee = styled.div`
  // width: 120px;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: ${({ theme }) => theme.sizing.xs}  0 0 0;
  background-color: ${({ theme }) => theme.fill.defaultMain};
  border: 1px solid ${({ theme }) => theme.border.defaultSubtle};
  border-radius: ${({ theme }) => theme.radius.xs};
  cursor: pointer;
`;

const AttendeeImages = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

const AttendeeAvatar = styled.img`
  width: ${({ theme }) => theme.sizing.xl};
  height: ${({ theme }) => theme.sizing.xl};
  border-radius: ${({ theme }) => theme.radius.xl};
  border: 1px solid ${({ theme }) => theme.border.defaultMain};
  // box-shadow: 2px 0px 4px rgba(0, 0, 0, 0.16);
  z-index: 2;
`;

const AttendeeVehicle = styled.img`
  width: ${({ theme }) => theme.sizing.xl};
  height: ${({ theme }) => theme.sizing.xl};
  border-radius: ${({ theme }) => theme.radius.xl};
  object-fit: cover;
  z-index: 1;
  margin-left: -8px;
  border: 1px solid ${({ theme }) => theme.border.defaultMain};
`;

const AttendeeInfo = styled.div`
  width: 100%;
  padding: ${({ theme }) => theme.sizing.xs};
  display: flex;
  flex-direction: column;
`;

const AvatarPlaceholder = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: ${({ theme }) => theme.sizing.xl};
  height: ${({ theme }) => theme.sizing.xl};
  border-radius: ${({ theme }) => theme.radius.xl};
  border: 1px solid ${({ theme }) => theme.border.defaultMain};
  background-color: ${({ theme }) => theme.fill.defaultWeak};
  z-index: 2;
`;

const VehiclePlaceholder = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: ${({ theme }) => theme.sizing.xl};
  height: ${({ theme }) => theme.sizing.xl};
  border-radius: ${({ theme }) => theme.radius.xl};
  border: 1px solid ${({ theme }) => theme.border.defaultMain};
  background-color: ${({ theme }) => theme.fill.defaultWeak};
  z-index: 1;
  margin-left: -8px;
`;